import { Icon } from '../icon.tsx';
import type { IconProps } from '../icon.tsx';

export function IconCheck(props: IconProps) {
	return (
		<Icon stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" {...props}>
			<path d="M5 12l5 5l10 -10" />
		</Icon>
	);
}
